/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The Dealer model module.
 * @module model/Dealer
 * @version 0.0.1
 */
class Dealer {
    /**
     * Constructs a new <code>Dealer</code>.
     * @alias module:model/Dealer
     */
    constructor() { 
        
        Dealer.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>Dealer</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Dealer} obj Optional instance to populate.
     * @return {module:model/Dealer} The populated <code>Dealer</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Dealer();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('affected_serials')) {
                obj['affected_serials'] = ApiClient.convertToType(data['affected_serials'], ['String']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Dealer</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Dealer</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['affected_serials'])) {
            throw new Error("Expected the field `affected_serials` to be an array in the JSON data but got " + data['affected_serials']);
        }

        return true;
    }


}



/**
 * @member {String} name
 */
Dealer.prototype['name'] = undefined;

/**
 * @member {Number} id
 */
Dealer.prototype['id'] = undefined;

/**
 * @member {Array.<String>} affected_serials
 */
Dealer.prototype['affected_serials'] = undefined;






export default Dealer;

